import { render, staticRenderFns } from "./ProfileCaseStudies.vue?vue&type=template&id=4dc48062&"
import script from "./ProfileCaseStudies.vue?vue&type=script&lang=js&"
export * from "./ProfileCaseStudies.vue?vue&type=script&lang=js&"
import style0 from "~/assets/css/profile/agile.css?vue&type=style&index=0&lang=css&"
import style1 from "./ProfileCaseStudies.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileCaseStudyBox: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/profile/right-column/case-studies/ProfileCaseStudyBox.vue').default,ProfileOverviewSection: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/profile/right-column/ProfileOverviewSection.vue').default})
